<div class='acc-cohort-tab-2-part'>
	This is tab 2
</div>